<mat-progress-bar *ngIf=" show_progressbar==true" class="mt-1"
                  mode="query"></mat-progress-bar>

<button class="m-1" *ngIf="show_action_button=='true'" mat-raised-button color="primary"
        (click)="get_sql_rows()">{{action_button_title}}</button>
<mat-form-field [hidden]="sqlRows ==undefined">
  <mat-label>Filter</mat-label>
  <input matInput (keyup)="applyFilter($event)" placeholder="Type to filter">
</mat-form-field>

<!--  <button mat-raised-button >select/deselect all</button>-->
<div [hidden]="sqlRows ==undefined" class="mat-elevation-z8">
  <table id="sqltbl" class="p-3 text-dark" mat-table [dataSource]="dataSource" matSort>

    <div *ngFor="let item of displayedColumns; let i = index">
      <div *ngIf="list_hidden_cols.toString().includes(item);else otherdiv">
        <ng-container matColumnDef={{item}}>
          <th hidden="true" mat-header-cell class="p-4" *matHeaderCellDef
              mat-sort-header> {{item.replace('_', ' ').toUpperCase()}} </th>
          <td hidden="true" matTooltip="Click to select" (click)="sendMessage_single_row(row)" class="p-4"
              *matCellDef="let row ;let in = index ">
            <mat-checkbox *ngIf="i==0 && ischeckbox ==true" (change)="log_item(row,$event)"></mat-checkbox>
            {{row[item]}} <<<
          </td>
        </ng-container>
      </div>
      <ng-template #otherdiv>
        <ng-container matColumnDef={{item}}>
          <th mat-header-cell class="p-4" *matHeaderCellDef
              mat-sort-header> {{item.replace('_', ' ').toUpperCase()}} </th>
          <td matTooltip="Click to select" (click)="sendMessage_single_row(row)" class="p-4"
              *matCellDef="let row ;let in = index ">
            <mat-checkbox *ngIf="i==0 && ischeckbox ==true" (change)="log_item(row,$event)"></mat-checkbox>
                  <mat-icon class="mt-2 mr-2" *ngIf="i==0 ">{{icon}}</mat-icon>
            {{row[item]}} </td>
        </ng-container>
      </ng-template>
    </div>

    <tr class="p-4" mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr class="p-4" mat-row *matRowDef="let row; columns: displayedColumns;">
    </tr>
  </table>
  <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
</div>





